export default {
  retrieveParentNotificationTemplateList (state, payload) {
    state.parentNotificationTemplateList = [].concat(payload.parentNotificationTemplateList)
  },
  getParentNotificationTemplateInfo (state, payload) {
    state.parentNotificationTemplateInfo = payload.parentNotificationTemplateInfo
  },
  deleteParentNotificationTemplate (state, payload) {
    state.parentNotificationTemplateList.forEach((item, index) => {
      if (item.id === payload.parentNotificationTemplateInfo.parent_notification_template_id) {
        state.parentNotificationTemplateList.splice(index, 1)
      }
    })
  },
  saveState (state, payload) {
    state.currentPage = payload.page ? payload.page : null
  }
}
